import styled from 'styled-components';

const DetailLabel = styled.span`
  color: var(--greyscale-shade);
  flex-shrink: 0;
  font-size: var(--font-size-regular);
  min-width: 180px;
`;

const DetailRow = styled.div`
  align-items: baseline;
  display: flex;
  gap: 30px;
`;

const DetailValue = styled.span`
  color: var(--greyscale-blackish);
  font-size: var(--font-size-regular);
  overflow-wrap: anywhere;
  white-space: pre-line;
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ModalFooterActions = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const NoValue = styled.span`
  color: var(--greyscale-concrete);
`;

const StatusDotWrapper = styled.span.attrs({ className: 'status-dot' })`
  align-items: center;
  color: var(--greyscale-blackish);
  display: inline-flex;
  font-size: var(--font-size-small);
  gap: 4px;
  line-height: var(--font-line-height-small);
  white-space: nowrap;
`;

const StatusValue = styled.span`
  align-items: center;
  color: var(--greyscale-blackish);
  display: inline-flex;
  font-size: var(--font-size-regular);
  gap: 6px;
  line-height: var(--font-line-height-regular);
`;

const DetailsModalLayout = {
  DetailLabel,
  DetailRow,
  DetailValue,
  DetailsContainer,
  ModalFooterActions,
  NoValue,
  StatusDotWrapper,
  StatusValue
};

export default DetailsModalLayout;
